var _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTaskProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.2,
    r: 5.2,
    fill: "none",
    stroke: "#006EFF",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5v2.7h2.1",
    fill: "none",
    stroke: "#006EFF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15.6,
    width: 20,
    height: 6.4,
    rx: 3.2,
    fill: "none",
    stroke: "#006EFF",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.4,
    y: 18,
    width: 9.2,
    height: 1.6,
    rx: 0.8,
    fill: "#006EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTaskProgress);
export default __webpack_public_path__ + "static/media/bg-task-progress.cb654f018421a44036397ec7e3eb9888.svg";
export { ForwardRef as ReactComponent };